import {Injectable} from '@angular/core';
import {AbstractControl, AsyncValidator, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import {catchError, first, map} from 'rxjs/operators';
import {Observable, ObservableInput, of, switchMap, timer} from 'rxjs';
import {CartListService} from 'src/app/api/generated';

// now we need to decorate this class with Injectable
@Injectable({
  providedIn: 'root',
})
export class CartNumberValidator implements AsyncValidator {
  instanceId: string;

  constructor(private _cartListService: CartListService) {
  }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const {value}: {value: string} = control;
    // Debounce before the request: every revalidation (keystroke, patchValue, form element
    // init) cancels the previous run — without the timer each of them was an http call.
    return timer(300).pipe(
      switchMap((): Observable<boolean> => this._cartListService.cartListValidCartNumber({number: value})),
      map((val: boolean): ValidationErrors | null => {
        return val === false ? {invalidCartNumber: true} : null
      }),
      catchError((): ObservableInput<ValidationErrors> => {
        return of({failedCartNumberCheck: true})
      }),
      first()
    );
  };
}

// Factory function to create an AsyncValidatorFn with parameters
export function cartNumberValidatorFactory(cartListService: CartListService, instanceId: string): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const validator = new CartNumberValidator(cartListService);
    validator.instanceId = instanceId;
    return validator.validate(control);
  };
}
